import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Field } from "redux-form";
import _ from "lodash";
import {
  TrashIcon,
  DocumentTextIcon,
  PhotoIcon,
} from "@heroicons/react/24/outline";
import { lastFieldChanged } from "@registrationaction";
import {
  renderFieldText,
  RenderFieldPhone,
  renderHiddenFieldText,
  renderFieldTextarea,
  renderFieldSelect,
  renderFieldCheckbox,
  renderFieldRadio,
  renderSingleCheckbox,
  renderDatePicker,
  renderAutoSelect,
} from "@basecomponent";
import { TICKET_FOLDER } from "@constant";
import AnyFilesDropOnly from "@anyfiledroponly";
import LocaleStrings from "@language";

const FieldItem = (props) => {
  const location = useLocation();
  const {
    source = "",
    form,
    autofill,
    formValues,
    interestList,
    eventData,
  } = props;
  const [userInterest, setUserInterest] = useState(
    formValues?.interest && Array.isArray(formValues?.interest)
      ? formValues?.interest
      : []
  );
  const [rerenderDom, setRerenderDom] = useState(0);

  useEffect(() => {
    let formKey = form?.key;
    let name = form?.name;

    if (formKey === "dynamicfield" && name === "interest") {
      setUserInterest(
        formValues?.interest && Array.isArray(formValues?.interest)
          ? formValues?.interest
          : []
      );
    }
  }, [form]);

  // console.log("Form Field :- ", form);
  let formKey = form?.key;
  let groupType = form?.type;
  let groupFields = form?.groupfields;
  let name = form?.name;
  let formLabel = form?.label;
  let isReadOnly = form?.isreadonly ?? false;
  let isHidden = form?.hidden ?? false;
  let isRequired = form?.required && !isReadOnly && !isHidden ? true : false;
  let isExclude = form?.exclude ?? false;
  let maxLength = form?.maxlen;
  let countrycode = form?.defaultvalue; // default country code checking
  let dropdowndisabled =
    countrycode && countrycode !== "" ? form?.isrestricted : false; // disabled country dropdownlist
  let filetype = "";
  let accept = "";
  if (formKey === "file") {
    filetype = form?.filetype;
    // console.log("filetype :- ", filetype);
    if (filetype === "image") {
      accept = "image/*";
    } else if (filetype === "video") {
      accept = "video/*";
    } else if (filetype === "audio") {
      accept = "audio/*";
    } else if (filetype === "document") {
      accept = "application/*";
      // accept =
      //   "application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/zip";
    }
  }
  let dropdownOptions = [];
  if (formKey === "dropdown") {
    _.forEach(form?.options, (o) => {
      dropdownOptions.push({ value: o.value, label: o.text });
    });
  }

  const handleLastFieldChanged = (e) => {
    let value = "";
    if (
      formKey === "checkboxes" ||
      formKey === "datepicker" ||
      formKey === "file" ||
      formKey === "dynamicfield"
    ) {
      value = e;
    } else if (formKey === "singlecheckbox") {
      value = e?.target?.checked;
    } else if (formKey === "dropdown") {
      if (typeof e === "object") {
        value = e?.value;
      } else {
        value = e?.target?.value;
      }
    } else {
      value = e?.target?.value;
    }
    if (source === "ticketassign") {
      props.updatedLastFieldChanged(form, value); // Parent props function call
    } else {
      props.lastFieldChanged(name);
    }
  };

  const onFilesDrop = (data, name) => {
    // console.log("data :- ", data);
    // console.log("name :- ", name);

    let fileArray = formValues?.[name] ?? [];
    fileArray.push(data);
    // console.log("new files :- ", fileArray);

    autofill(`${name}`, fileArray);
    setRerenderDom((prev) => prev + 1);
    handleLastFieldChanged(fileArray);
  };

  const onFilesRemove = (index, name) => {
    let newFileArray = formValues?.[name] ?? [];
    _.pullAt(newFileArray, index);
    // console.log('newFileArray :- ', newFileArray)

    autofill(`${name}`, newFileArray?.length > 0 ? newFileArray : null);
    setRerenderDom((prev) => prev + 1);
    handleLastFieldChanged(newFileArray?.length > 0 ? newFileArray : null);
  };

  const renderFiles = () => {
    let fileArray = formValues?.[name] ?? [];
    let maxfile = form?.maxupload ?? 1;
    let existingFilesCount = fileArray?.length;

    // console.log("fileArray :- ", name, fileArray);
    // console.log("existingFilesCount :- ", existingFilesCount);
    // console.log("maxfile :- ", maxfile);

    return (
      <>
        {_.map(fileArray, (item, index) => {
          // console.log('index :- ', index);
          let fileName = "";
          if (item && item.file) {
            fileName = item?.filename;
          }

          let icon = <DocumentTextIcon className="w-5 h-5" />;
          if (fileName !== "") {
            let fileType = fileName.split(".").pop();

            if (
              fileType === "svg" ||
              fileType === "png" ||
              fileType === "jpg" ||
              fileType === "jpeg"
            ) {
              icon = <PhotoIcon className="w-5 h-5" />;
            } else if (fileType === "pdf") {
              icon = <DocumentTextIcon className="w-5 h-5" />;
            }
          }

          return (
            <div
              key={`${name}_file_${index}`}
              className={`uploaded-attachment-displaybox`}
            >
              <>{icon}</>
              <div className="file-name custom-text-primary-md-normal">
                {fileName}
              </div>

              <div className="flex items-center space-x-3">
                <TrashIcon
                  className="w-5 h-5 cursor-pointer"
                  onClick={() => onFilesRemove(index, name)}
                />
              </div>
            </div>
          );
        })}

        <div>
          {existingFilesCount < maxfile ? (
            <AnyFilesDropOnly
              onFileSave={(data) => onFilesDrop(data, name)}
              accept={accept}
              displayText={LocaleStrings.kFileDragDropText}
              className=""
            />
          ) : (
            <div className="div-input-field">
              <span className="custom-text-secondary-sm-medium">
                {LocaleStrings.kMaxFileUpload}
              </span>
            </div>
          )}
        </div>
      </>
    );
  };

  const handleUserInterest = (item) => {
    var array = userInterest;

    if (_.includes(array, item.interestid)) {
      var filter = _.filter(array, function (n) {
        return parseInt(n) !== parseInt(item.interestid);
      });
      array = filter;
    } else {
      array = [...array, item.interestid];
    }

    setUserInterest(array);
    props.autofill(`${name}`, array);
    handleLastFieldChanged(array);
  };

  const _renderInterests = () => {
    return _.map(interestList, (item, index) => {
      return (
        <div
          key={`int_key${index}`}
          className={`custom-item-vcenter gap-1 ${
            _.includes(userInterest, item.interestid)
              ? "selected-interest"
              : "interests"
          }`}
          onClick={() => handleUserInterest(item)}
        >
          {item.interest}
          {/* {_.includes(userInterest, item.interestid) ? (
            <CheckIcon className="w-5 h-5" />
          ) : (
            ""
          )} */}
        </div>
      );
    });
  };

  let params = location.search;

  return (
    <>
      {/* Checkout Fields */}
      <div>
        {isHidden || isExclude ? (
          <></>
        ) : (
          <>
            {formKey === "textinput" || formKey === "numberinput" ? (
              <>
                {name === "phonenumber" || name === "whatsapp" ? (
                  <Field
                    name={name}
                    label={formLabel}
                    type={"number"}
                    component={RenderFieldPhone}
                    mandatory={isRequired}
                    disabled={isReadOnly}
                    maxlength={maxLength}
                    eventid={eventData?.eventid}
                    onChange={(e) =>
                      handleLastFieldChanged({ target: { value: e, name } })
                    }
                    countyecode={countrycode}
                    isrestricted={dropdowndisabled}
                  />
                ) : (
                  <Field
                    name={name}
                    label={formLabel}
                    type={formKey === "textinput" ? "text" : "number"}
                    component={renderFieldText}
                    mandatory={isRequired}
                    disabled={isReadOnly}
                    maxlength={maxLength}
                    onChange={handleLastFieldChanged}
                  />
                )}
              </>
            ) : formKey === "textarea" ? (
              <Field
                name={name}
                label={formLabel}
                component={renderFieldTextarea}
                mandatory={isRequired}
                disabled={isReadOnly}
                maxlength={maxLength}
                onChange={handleLastFieldChanged}
              />
            ) : formKey === "checkboxes" ? (
              <Field
                name={name}
                label={formLabel}
                component={renderFieldCheckbox}
                mandatory={isRequired}
                disabled={isReadOnly}
                opts={form?.options}
                onChange={handleLastFieldChanged}
              />
            ) : formKey === "radiobuttons" ? (
              <Field
                name={name}
                label={formLabel}
                component={renderFieldRadio}
                mandatory={isRequired}
                disabled={isReadOnly}
                opts={form?.options}
                onChange={handleLastFieldChanged}
              />
            ) : formKey === "dropdown" ? (
              <Field
                name={name}
                label={formLabel}
                placeholder={LocaleStrings.kSelectPlaceholder}
                component={
                  name === "country" ? renderAutoSelect : renderFieldSelect
                }
                mandatory={isRequired}
                disabled={isReadOnly}
                isMulti={false}
                options={dropdownOptions}
                onChange={handleLastFieldChanged}
              />
            ) : formKey === "datepicker" ? (
              <Field
                name={name}
                label={formLabel}
                component={renderDatePicker}
                mandatory={isRequired}
                disabled={isReadOnly}
                onChange={handleLastFieldChanged}
              />
            ) : formKey === "hyperlink" ? (
              <a
                href={form?.link}
                target="blank"
                className="custom-text-theme-md-medium"
              >
                <div>{formLabel}</div>
              </a>
            ) : formKey === "label" ? (
              <label className="control-label-top">{formLabel}</label>
            ) : formKey === "paragraph" ? (
              <p className="custom-text-primary-md-normal">{formLabel}</p>
            ) : formKey === "singlecheckbox" ? (
              <>
                {name === "termsconditions" ? (
                  <Field
                    name={name}
                    htmllabel={`
                      <span>
                        ${formLabel}
                        <br />
                        <a href='${TICKET_FOLDER}/terms-conditions${params}' target='_blank'><u><b><span>${LocaleStrings.kTermsAndConditions}</span></b></u></a>
                        &emsp; | &emsp;
                        <a href='${TICKET_FOLDER}/privacy-policy${params}' target='_blank'><u><b><span>${LocaleStrings.KPrivacyPolicy}</span></b></u></a>
                      </span>`}
                    component={renderSingleCheckbox}
                    value="1"
                    type="checkbox"
                    mandatory={isRequired}
                    onChange={handleLastFieldChanged}
                  />
                ) : (
                  <Field
                    name={name}
                    label={formLabel}
                    component={renderSingleCheckbox}
                    value="1"
                    type="checkbox"
                    mandatory={isRequired}
                    onChange={handleLastFieldChanged}
                  />
                )}
              </>
            ) : formKey === "file" ? (
              <div className="space-y-1 2xs:space-y-1.5">
                <label className="control-label-top col-span-12">
                  {formLabel}{" "}
                  <span className="custom-text-secondary-sm-medium">
                    ({LocaleStrings.kMaxUploadText} : {form?.maxupload})
                  </span>
                  {isRequired ? <span className="label-mandatory">*</span> : ""}
                </label>
                {renderFiles()}
                <Field
                  name={`${name}`}
                  type="text"
                  component={renderHiddenFieldText}
                />
              </div>
            ) : formKey === "dynamicfield" ? (
              <>
                {name === "interest" ? (
                  <div className="space-y-1 2xs:space-y-1.5">
                    <label className="control-label-top col-span-12">
                      {formLabel}
                      {isRequired ? (
                        <span className="label-mandatory">*</span>
                      ) : (
                        ""
                      )}
                    </label>
                    <div className="interest-section">{_renderInterests()}</div>
                    <Field
                      name={`${name}`}
                      type="text"
                      component={renderHiddenFieldText}
                    />
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : formKey === "group" ? (
              <>
                {groupType === "abstract" ? (
                  <div className="space-y-1 2xs:space-y-1.5">
                    <label className="control-label-top col-span-12">
                      {groupFields?.[0]?.label}
                    </label>
                    <p className="custom-text-secondary-sm-normal col-span-12">
                      {groupFields?.[1]?.label}
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    interestList: state?.eventInterestsData?.data,
    eventData: state.eventData,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ lastFieldChanged }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FieldItem);
